export default "__VITE_ASSET__AOA8L_y1__"